var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vue-outer-wrap homepage"},[(_vm.readyToRenderPage)?_c('div',{staticClass:"inner-wrap"},[(_vm.isMobile() || this.isTablet())?_c('mobile-home'):_vm._e(),(!_vm.isMobile() && !this.isTablet())?_c('desktop-home'):_vm._e()],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }